<template>
  <div class="text-center" v-if="item">
    <v-dialog scrollable :persistent="persistent" v-model="dialog" ref="dlgInfo" width="850">
      <template v-slot:activator="{}"></template>

      <v-card>
        <v-card-title :class="`headline mb-6 ` + item.opsi ? item.opsi.colorHeader + ' white--text' : 'primary white--text'">{{ item.judul }}</v-card-title>

        <v-card-text>
          <v-row class="pa-2">
            <v-col cols="12">
              <div class="my-0 py-0 black--text" v-html="cek(item.informasi)"></div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <m-button class="my-2 mx-6" text color="info white--text" :textButton="item.opsi ? item.opsi.closeLabel : 'Tutup'" action="toClose" @toClose="dialog = false"></m-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "komponen-notifikasi-dialog",
  data() {
    return {
      dialog: false,
      item: null,
      persistent: false
    };
  },
  // props: {
  //   // Pilihan format tipe card organisasi atau tampilan card data global
  //   title: {
  //     type: String,
  //     default: "Informasi"
  //   },
  //   konten: {
  //     type: String,
  //     default: ""
  //   },
  //   persistent: {
  //     type: Boolean,
  //     default: false
  //   }
  // },

  methods: {
    open(val) {
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
        this.item = val;
      });
    },
    cek(val) {
      let result = val.replace("[USER]", this.current_user.name);
      return result;
    },
    cekStatusDialog(val) {
      if (val && val.opsi) {
        var objCheck = this.$store.getters[val.opsi.statusDialog.store];
        var objSyarat = this.$store.getters[val.opsi.statusDialog.store_syarat];
        this.persistent = val.opsi.statusDialog.persistent;
        // apakah ada data kelas yang terdaftar, flexible bisa data selain kelas
        if (val.opsi.statusDialog.pengecekan === "is_terdaftar") {
          return objCheck.length > 0 ? true : false;
        }
        // apakah pengecekannya hanya dari value variable yang dikirim oleh API
        else if (val.opsi.statusDialog.pengecekan === "is_api_variable") {
          return objCheck[val.opsi.statusDialog.variable] ? false : true;
        } else if (val.opsi.statusDialog.pengecekan === "combination") {
          const is_lulus =
            objCheck.length > 0 &&
            objCheck[0].kelasku.length === val.opsi.statusDialog.minSizeKelas &&
            objCheck[0].kelasku[val.opsi.statusDialog.minSizeKelas - 1].progress.status === 1
              ? true
              : false;

          const api_variable = objSyarat[val.opsi.statusDialog.variable] ? false : true;

          return is_lulus && api_variable;
        } else {
          return true;
        }
      } else {
        return val ? true : false;
      }
    }
  }
};
</script>
